import { createLikeableSchema, LikeableEntity } from 'mk2/containers/Like/Like.schemas';
import {
    Entity,
    PhotoEntity,
    PhotoSchema,
    UserEntity,
    UserSchema,
} from 'mk2/schemas';
import { schema } from 'normalizr';

export interface WikiCategoryEntity extends Entity {
    id: number;
    name: string;
    slug: string;
    categoryArticleId: number;
    categoryArticleSlug: string;
}

export interface ExperienceEntity extends Entity {
    id: number;
    text: string;
    title: string;
    created: string;
    authorUser: UserEntity;
    likeable: LikeableEntity;
    positives: string[];
    negatives: string[];
    starsCount: number;
    article: ArticleEntity;
}

export interface AST {
    type: string;
    elements?: AST[];
    text?: string;
    obj_type?: string;
    obj_id?: number;
}

export enum ASTLinkedObjectType {
    FORUM_POST_DETAIL = 'forum_post_detail',
    WIKI_ARTICLE = 'wiki_article',
    PHOTOBLOG_ARTICLE = 'photoblog_article',
}

export interface ASTLinkedObjectsData {
    [ASTLinkedObjectType.WIKI_ARTICLE]?: {
        [articleId: number]: {url: string, title: string, countExperiences: number},
    };
}

export interface ArticleEntity extends Entity {
    id: number;
    author: UserEntity;
    createdAt: string;
    modifiedAt: string;
    deletedAt: string;
    title: string;
    instrumentalTitle: string;
    photos: PhotoEntity[];
    bodyAST: AST;
    countTopicContributors: {[topicSlug: string]: number};
    linkedObjects: ASTLinkedObjectsData;
    experiencesAllowed: boolean;
    experiencesStarsAllowed: boolean;
    experiencesPositivesNegativesAllowed: boolean;
    slug: string;
    likeable: LikeableEntity;
    experiences: ExperienceEntity[];
    category: WikiCategoryEntity;
    disabledAds: boolean;
    seoTitle: string; // text co ide do <title>...</title> a google zobrazuje v SERP
    seoDescription: string; // text co ide <meta name="description" content="..."> a google zobrazuje v SERP
    articleConceptPath: Array<{
        conceptId: number;
        title: string;
        articleSlug: string;
        categorySlug: string;
    }>;
}

export const WikiCategorySchema = new schema.Entity('wikiCategories');

export const ExperienceSchema = new schema.Entity('experience', {
    authorUser: UserSchema,
    likeable: createLikeableSchema('wiki-experience'),
});

export const ArticleSchema = new schema.Entity('wikiArticles', {
    author: UserSchema,
    photos: [PhotoSchema],
    experiences: [ExperienceSchema],
    category: WikiCategorySchema,
    likeable: createLikeableSchema('wiki-article'),
});

ExperienceSchema.define({ article: ArticleSchema });

export interface ArticleLinkDataEntity extends Entity {
    title: string;
    categorySlug: string;
    articleSlug: string;
    experiencesCount: number;
}

export const ArticleLinkDataSchema = new schema.Entity('articleLinkData', {});
